var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRobotContrast = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85 42.5C85 65.9721 65.9721 85 42.5 85C19.0279 85 0 65.9721 0 42.5C0 19.0279 19.0279 0 42.5 0C65.9721 0 85 19.0279 85 42.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8961 62.6995C37.2849 62.6995 40.8165 62.9069 40.8165 65.9143C40.8165 68.9218 38.0735 72.1021 33.6847 72.1021C29.2959 72.1021 24.9414 68.8872 24.9414 65.9143C24.9414 62.9414 28.5073 62.6995 32.8961 62.6995Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 2.65318,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8004 63.3817C59.5523 63.3817 62.5714 63.559 62.5714 66.13C62.5714 68.701 60.2265 71.4198 56.4745 71.4198C52.7226 71.4198 49 68.6715 49 66.13C49 63.5885 52.0484 63.3817 55.8004 63.3817Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 2.26817,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2095 32.7959C63.2095 37.1847 63.4169 40.7163 66.2861 40.7163C69.1552 40.7163 72.2318 37.9733 72.2318 33.5845C72.2318 29.1957 69.1552 24.8412 66.2861 24.8412C63.4169 24.8412 63.2095 28.4071 63.2095 32.7959Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 0.663296
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2617 68.0084H29.2148C23.1653 68.0084 18.1875 63.071 18.1875 57.0707V23.9377C18.1875 17.9374 23.1653 13 29.2148 13H53.2617C59.3112 13 64.289 17.9374 64.289 23.9377V57.0707C64.289 63.071 59.3458 68.0084 53.2617 68.0084Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 0.663296
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6546 68.0084H39.2963C33.2469 68.0084 28.269 63.071 28.269 57.0707V24.8755C28.3036 18.8752 33.2469 13.9377 39.3309 13.9377H58.6892C64.7387 13.9377 69.7165 18.8752 69.7165 24.8755V57.0707C69.6819 63.071 64.7387 68.0084 58.6546 68.0084Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.98989,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58.205 40.7163H41.5776C37.5677 40.7163 34.2837 37.4589 34.2837 33.4816V27.5156C34.2837 23.5382 37.5677 20.2809 41.5776 20.2809H58.2396C62.2495 20.2809 65.5335 23.5382 65.5335 27.5156V33.5159C65.4989 37.4589 62.2149 40.7163 58.205 40.7163Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.98989,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56.978 33.1387C56.978 34.2016 57.8422 35.0588 58.9139 35.0588C60.5325 35.0588 63.1062 31.7546 63.1062 30.348C63.1062 28.0974 60.293 24.944 58.9139 24.944C57.8422 24.944 56.978 25.8012 56.978 26.8641V33.1387Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 0.663296
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2361 28.5891C61.5306 28.578 61.7179 28.274 61.6973 27.98C61.6889 27.8614 61.6823 27.7378 61.6233 27.5256C61.4903 27.0477 61.2085 26.6245 60.8187 26.3176C60.429 26.0106 59.9515 25.8359 59.4557 25.8186C59.132 25.8074 58.8114 25.8637 58.5137 25.9819C58.2503 26.0864 58.1907 26.4116 58.3501 26.6458C58.5095 26.88 58.8305 26.9285 59.1079 26.8707C59.2099 26.8494 59.3147 26.8403 59.4201 26.844C59.698 26.8536 59.9655 26.9516 60.184 27.1236C60.4024 27.2956 60.5603 27.5327 60.6349 27.8006C60.6518 27.8616 60.6643 27.9234 60.6722 27.9857C60.7105 28.2862 60.9333 28.6006 61.2361 28.5891Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6353 33.1387C47.6353 34.2016 48.4995 35.0588 49.5711 35.0588C51.1897 35.0588 53.7634 31.7546 53.7634 30.348C53.7634 28.0974 50.9503 24.944 49.5711 24.944C48.4995 24.944 47.6353 25.8012 47.6353 26.8641V33.1387Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 0.663296
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8933 28.5891C52.1878 28.578 52.3752 28.274 52.3545 27.98C52.3461 27.8614 52.3395 27.7378 52.2805 27.5256C52.1475 27.0477 51.8657 26.6245 51.476 26.3176C51.0862 26.0106 50.6088 25.8359 50.113 25.8186C49.7892 25.8074 49.4686 25.8637 49.1709 25.9819C48.9076 26.0864 48.8479 26.4116 49.0073 26.6458C49.1667 26.88 49.4878 26.9285 49.7651 26.8707C49.8671 26.8494 49.9719 26.8403 50.0774 26.844C50.3552 26.8536 50.6228 26.9516 50.8412 27.1236C51.0596 27.2956 51.2176 27.5327 51.2921 27.8006C51.309 27.8616 51.3215 27.9234 51.3294 27.9857C51.3678 28.2862 51.5905 28.6006 51.8933 28.5891Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4026 32.7959C21.4026 37.1847 21.1952 40.7163 18.1877 40.7163C15.1803 40.7163 12 37.9733 12 33.5845C12 29.1957 15.2149 24.8412 18.1877 24.8412C21.1606 24.8412 21.4026 28.4071 21.4026 32.7959Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 2.65318,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.7157 55.4055L55.0198 56.9621C54.5509 57.2328 53.9648 56.8944 53.9648 56.353L53.9648 53.1046C53.9648 52.5632 54.5509 52.2248 55.0198 52.4955L57.7157 54.0521V53.1046C57.7157 52.5632 58.3018 52.2248 58.7707 52.4955L61.4666 54.0521V53.1046C61.4666 52.5632 62.0527 52.2248 62.5216 52.4955L65.3348 54.1197C65.8036 54.3904 65.8036 55.0672 65.3348 55.3379L62.5216 56.9621C62.0527 57.2328 61.4666 56.8944 61.4666 56.353V55.4055L58.7707 56.9621C58.3018 57.2328 57.7157 56.8944 57.7157 56.353V55.4055Z",
    fill: "#1E1E1E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRobotContrast);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/RobotContrast.2477ba27a8ad291b3122f7d7f579546b.svg";